// extracted by mini-css-extract-plugin
export default {"invoicePreview":"invoice-preview_invoicePreview__wIHjn"};